import { Backend } from '../_axios';

export default {

  UserIssues() {
    return Backend.post('/api/reports/UserIssues');
  },

};
